import React, {ReactNode} from 'react'

// Types ----

type PageSectionProps = {
  title: string;
  children: ReactNode;
}

// Component ----

function PageSection({title, children}: PageSectionProps) {
  return (
    <div className="shadow bg-white rounded-md">
      <div className='flex p-4 sm:px-6 border-b border-gray-200'>
        <h2 className='text-gray-900 text-lg font-medium'>{title}</h2>
      </div>
      <div className='p-4 sm:p-6'>
        {children}
      </div>
    </div>
  );
}

export {PageSection};